// extracted by mini-css-extract-plugin
export var boxItems = "_9v-1";
export var boxItemsLg = "_9v-2";
export var button = "_9v-7";
export var buttonHoverless = "_9v-9";
export var buttonLg = "_9v-8";
export var filterGroupBox = "_9v-0";
export var icon = "_9v-3";
export var iconSecondary = "_9v-6";
export var iconWrapper = "_9v-4";
export var iconWrapperLg = "_9v-5";
export var truncatedLabel = "_9v-a";